import React , {useEffect} from 'react'
import './components.css'



export default ()=> {      
    // let handleNumChange = (e) => {
    //     let comp = e.target   
    //     comp.value = isNaN(comp.value) || comp.value == '' ? parseInt( comp.placeholder)  : comp.value
    //     comp.value = parseFloat(comp.value) > comp.max ? comp.max : (
    //          parseFloat(comp.value) < comp.min ? comp.min : comp.value
    //         )
    //     comp.value = Math.round(parseFloat(comp.value))  
    // }

    let HHOptions = Array.from(Array(49) , (_, idx) => idx ) 
    let MMSSOptions = Array.from(Array(60) , (_,idx) => idx )

    let staticDynamic = [ ]
    staticDynamic.push({ val: "11" , text: "Static QR Code"  , default: false})
    staticDynamic.push({ val: "12" , text :"Dynamic QR Code" , default: true } )

    let timeoutEnable  = [    ]
    timeoutEnable.push({ val: 'Y' , text: "Yes"  , default: false } )
    timeoutEnable.push( { val: 'N' , text : "No" , default: true}     )  

    useEffect(()=>{
        document.getElementById("MerchantTimeOuttimeHH")
            .querySelector( 'option[value="24"]') .selected = true  
            
        document.getElementById("MerchantTimeOuttimeMM")
            .querySelector( 'option[value="1"]') .selected = true  
        document.getElementById("MerchantTimeOuttimeSS")
            .querySelector( 'option[value="1"]') .selected = true  
        
        // document.getElementById("MerchantTimeOuttimeSS").value = 1
        // document.getElementById("MerchantTimeOuttimeMM").value = 1
    })

    return (
    <div> 
        <h2>QR Code Time-out Setting:</h2>
        <div className='panel'>
            <label>Static/Dynamic QR Code</label> 
            <select id="PointofInitiationMethod" >
                    {staticDynamic.map((x )=>{
                        return   <option value={x.val} 
                            selected={x.default}
                        >
                            {x.text}
                        </option>
                    })}
            </select>
            <label>Enable Merchant Time-out setting</label>
            <select id="MerchantTimeOuttimeEnabled">
                {
                    timeoutEnable.map((tout) => {
                        return <option value= {tout.val}
                                        selected={tout.default}
                        > 
                        {tout.text} </option> 
                    })
                }
            </select>
            <label> Merchant Time-out Time (HH)</label>
            <select id = "MerchantTimeOuttimeHH">
                {
                    HHOptions.map((x)=>{
                        return <option value={x} >{x}</option>
                    })
                }
            </select>
            {/* <input type="number"   min="0"  max="48" step="1" id="MerchantTimeOuttimeHH" placeholder="24"  onChange={e=>handleNumChange(e)}   />  */}
            <label> Merchant Time-out Time (MM)</label>
            <select id = "MerchantTimeOuttimeMM">
                {
                    HHOptions.map((x)=>{
                        return <option value={x} >{x}</option>
                    })
                }
            </select>
            {/* <input type="number"   min="0"  max="59" step="1"  id="MerchantTimeOuttimeMM"  placeholder="1"  onChange={e=>handleNumChange(e)} />  */}
 
            <label> Merchant Time-out Time (SS)</label>             
            <select id = "MerchantTimeOuttimeSS">
                {
                    HHOptions.map((x)=>{
                        return <option value={x} >{x}</option>
                    })
                }
            </select>
            {/* <input type="number"   min="0"  max="59" step="1"  id="MerchantTimeOuttimeSS"  placeholder="1"  onChange={e=>handleNumChange(e)} />  */}

        </div>
    </div>
)

}